import { render, staticRenderFns } from "./CancelFormKT.vue?vue&type=template&id=13afcff2&scoped=true&"
import script from "./CancelFormKT.vue?vue&type=script&lang=js&"
export * from "./CancelFormKT.vue?vue&type=script&lang=js&"
import style0 from "./CancelFormKT.vue?vue&type=style&index=0&id=13afcff2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13afcff2",
  null
  
)

export default component.exports